import I18n from "^/config/i18n";

function sortOptions() {
  return [
    {
      value: `publishFromDate.desc`,
      key: I18n.t("Blog sort by latest first"),
    },
    {
      value: `publishFromDate.asc`,
      key: I18n.t("Blog sort by oldest first"),
    },
    {
      value: "author.desc",
      key: I18n.t("Blog sort by author"),
    },
    {
      value: "title.asc",
      key: I18n.t("Blog sort by A-Z title"),
    },
    {
      value: "title.desc",
      key: I18n.t("Blog sort by Z-A title"),
    },
  ];
}

export default sortOptions;
